import React, { FC } from 'react';
import  styles from './Twitter.module.scss';


interface TwitterProps {}

const Twitter: FC<TwitterProps> = () => {
  return (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_31_3343)">
<g clipPath="url(#clip1_31_3343)">
<g clipPath="url(#clip2_31_3343)">
<path d="M11.8575 8.46425L19.1391 0H17.4136L11.0909 7.34943L6.04109 0H0.216675L7.85306 11.1137L0.216675 19.9897H1.94228L8.61917 12.2285L13.9522 19.9897H19.7766L11.8575 8.46425ZM9.494 11.2115L8.72033 10.1048L2.56404 1.29901H5.21447L10.1827 8.40558L10.9563 9.51225L17.4144 18.7498H14.764L9.494 11.2115Z" fill="black"/>
</g>
</g>
</g>
<defs>
<clipPath id="clip0_31_3343">
<rect width="20" height="20" fill="white"/>
</clipPath>
<clipPath id="clip1_31_3343">
<rect width="20" height="20" fill="white"/>
</clipPath>
<clipPath id="clip2_31_3343">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>

  );
};



export default Twitter;
